<!-- Copyright: Seán I. O'Donoghue -->
<!-- A count in square brackets beside a heading or a label (Seán, 2026-10-26): "Posters -->
<!-- [1,076]", or the part shown of the whole, "[47/1,076]"; one look everywhere, and the -->
<!-- thousands separated by default. Where it sits (its offset, hidden on phones) is the user's -->
<template>
  <span class="count">[{{ text }}]</span>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  count: {type: [Number, String], required: true},
  total: {type: [Number, String], default: ""} // the whole, when count is the part shown
});

// 1076 → "1,076"; text that isn't a number is shown as it is
function getGrouped(value) {
  const number = Number(value);
  return value === "" || Number.isNaN(number) ? String(value) : number.toLocaleString("en-US");
}

const text = computed(() => {
  const count = getGrouped(props.count);
  return props.total === "" ? count : `${count}/${getGrouped(props.total)}`;
});
</script>

<style scoped>
/* smaller and lighter than the heading or label beside it */
.count {
  font-size: 1rem;
  font-weight: 100;
}
</style>
